
<header class="header" id="stickyheader">
 
      
    <nav class="navbar navbar-expand-lg">
        <div class="container-fluid">
            <a class="navbar-brand" routerLink="/home">
                <img src="assets/images/logo/coincuriosity.svg" class="img-fluid logo" alt="coincuriosity logo">
            </a>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <label class="hamburger ">
                    <input type="checkbox">
                    <svg viewBox="0 0 32 32">
                        <path class="line line-top-bottom"
                            d="M27 10 13 10C10.8 10 9 8.2 9 6 9 3.5 10.8 2 13 2 15.2 2 17 3.8 17 6L17 26C17 28.2 18.8 30 21 30 23.2 30 25 28.2 25 26 25 23.8 23.2 22 21 22L7 22">
                        </path>
                        <path class="line" d="M7 16 27 16"></path>
                    </svg>
                </label>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-baseline">
                    <a class="navbar-brand mobile-res logoSidebar " routerLink="/home">
                        <img src="assets/images/logo/coincuriosity.svg" class="img-fluid logo" alt="coincuriosity logo">
                    </a>
                    <li class="nav-item" *ngIf="auth.isAuthenticated">
                        <a class="nav-link" routerLink="/user/dashboard" routerLinkActive="active">Member Dashboard</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/master-collection" routerLinkActive="active">Master
                            Collection</a>
                    </li>

                    <li class="nav-item" *ngIf="auth.isAuthenticated">
                        <a class="nav-link" routerLink="/coins/identify-collection" routerLinkActive="active">Identify
                            coins</a>
                    </li>

                    <li class="nav-item" *ngIf="auth.isAuthenticated">
                        <a class="nav-link" routerLink="/coins/assess-collection" routerLinkActive="active">Assess
                            coins</a>
                        <span class="item-count">{{iarCount}}</span>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" routerLink="/about-us" routerLinkActive="active">About</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/resources" routerLinkActive="active">Resources </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/faq" routerLinkActive="active">Faq</a>
                    </li>
                    <li class="nav-item dropdown" *ngIf="auth.isAuthenticated">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            
                                <img  [src]="user?.image_url || 'assets/images/avatars/profile-avatar.png'" width="30px"
                                alt="" class="rounded-circle">

                            <span class="username ">{{user?.display_name}}</span>


                            <span class="drop_icon ml-1">
                                <i class="fas fa-chevron-down"></i>
                            </span>
                        </a>
                        <ul class="dropdown-menu dropdown-menu-end  dropdown-menu-dark" data-bs-popper="static">


                            <li>
                                <a class="dropdown-item waves-effect" [routerLink]="['/user/dashboard']">
                                    <i class="fas fa-chart-line me-2"></i><span class="align-middle">
                                        Dashboard</span>
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item waves-effect" [routerLink]="['/user/profile']">
                                    <i class="far fa-user me-2"></i><span class="align-middle">
                                        My Profile</span>
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item waves-effect" [routerLink]="['/user/profile/edit']">
                                    <i class="far fa-pencil me-2"></i><span class="align-middle">
                                        Edit Profile</span>
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item waves-effect" [routerLink]="['/user/billing']">
                                    <i class="far fa-credit-card me-2"></i><span class="align-middle">
                                        Billing &amp; Membership</span>
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item waves-effect" [routerLink]="['/user/settings']">
                                    <i class="fas fa-users-cog me-2"></i><span class="align-middle">
                                      Change Password</span>
                                </a>
                            </li>
                            <li>
                                <div class="dropdown-divider"></div>
                            </li>

                            <li>
                                <div class=" px-4 pt-2 pb-1">
                                    <div class="header-buttons   justify-content-center" *ngIf="auth.isAuthenticated">
                                        <button type="button" (click)="auth.logoutUser()"
                                            class="btn header-btn header-update_btn ">Logout</button>

                                    </div>
                                </div>
                            </li>
                        </ul>

                    </li>


                    <div class="header-buttons" *ngIf="!auth.isAuthenticated">
                        <button type="button" (click)="routing.navigate('/user/login')"
                            class="btn header-btn margin-x-35">Login</button>
                        <button type="button" (click)="routing.navigate('/user/join')" class="btn header-btn">Join
                            Now</button>
                    </div>
           


                </ul>



            </div>
        </div>
    </nav>

</header>
